import { Component, OnInit } from '@angular/core';
import { AccountDetailsService } from '../services/account-details.service';
import { LoginService } from '../services/login.service';
import { AlarmsService } from '../services/alarms-service.service';
import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { DxChartModule, DxChartComponent, DxButtonModule, DxDateBoxModule } from 'devextreme-angular';
import moment from 'moment';
import { CurrentAccount } from '../models/AccountModel';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-status-container',
  templateUrl: './status-container.component.html',
  styleUrls: ['./status-container.component.css']
})
export class StatusContainerComponent implements OnInit {
  streetAddress: string;
  cityStateZip: string;
  acctNumber: string;
  alarms: any = {};
  emails: any = [];
  textAlarmTypes: string;
  emailAlarmTypes: string;
  phoneNums: any = [];
  alarmEmail: string;
  alarmPhone: string;
  hasAlarmContactInfo: boolean;
  hasAlarmEmail: boolean;
  hasAlarmPhone: boolean;
  showCalendar: boolean;
  showSuccess: boolean;
  showSuccessReport: boolean;
  showError: boolean;
  showReportIssue: boolean;
  showIssueButton: boolean;
  now = Date.now();
  minDate = moment(this.now).format('LLL');
  currentAccount: CurrentAccount;
  issueMessage: string;
  error: string;
  acctIndexID: any;

  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService,
    private alarmsService: AlarmsService,
    private spinnerService: Ng4LoadingSpinnerService
  ) { }

  ngOnInit() {
    this.showCalendar = false;
    this.hasAlarmContactInfo = false;
    this.hasAlarmEmail = false;
    this.hasAlarmPhone = false;
    this.showSuccess = false;
    this.showError = false;
    this.showSuccessReport = false;
    this.showReportIssue = false;
    this.showIssueButton = true;

    this.loginService.getUserContext()
      .subscribe((ctx) => {
        if (ctx) {
          this.acctIndexID = this.getActiveAcctIndex(ctx.accountsWithDevices, ctx.activeAcctId);

          this.acctNumber = ctx.accountDetails[this.acctIndexID].accountDetails.accountNumber;
          this.streetAddress = ctx.accountDetails[this.acctIndexID].accountDetails.address1 + " " + (ctx.accountDetails[this.acctIndexID].accountDetails.address2 !== null ? ctx.accountDetails[this.acctIndexID].accountDetails.address2 : "");
          this.cityStateZip = ctx.accountDetails[this.acctIndexID].accountDetails.city + ", " + ctx.accountDetails[this.acctIndexID].accountDetails.state + " " + ctx.accountDetails[this.acctIndexID].accountDetails.zipcode;

          let accountsWithDevices = ctx.accountsWithDevices[this.acctIndexID];

          let orgUnitId = accountsWithDevices.orgUnitId;
          let DeviceId = accountsWithDevices.deviceId;
          this.getFlowAlarms(orgUnitId, DeviceId);

          this.getAllAlarms(orgUnitId, DeviceId);

          this.currentAccount = {
            OrgUnitId: accountsWithDevices.orgUnitId,
            DeviceId: accountsWithDevices.deviceId,
            AccountId: accountsWithDevices.accountId
          }
        }
      });
  }

  getActiveAcctIndex(accts, activeAcctID) {
    var acctIDIndex = 0;

    //get correct acct based on selected active acctid
    for (var i = 0; i < accts.length; i++) {
      let acct = accts[i];
      if (acct.accountId == activeAcctID) {
        acctIDIndex = i;
        break;
      }
    }
    return acctIDIndex;
  }

  showDisconnectCalendar() {
    this.showCalendar = true;
  }

  reportIssue() {
    this.showReportIssue = true;
  }

  reportOutage(currentAccount, issueMessage) {
    if (issueMessage === undefined) {
      this.error = "You must enter a message to proceed";
      this.showError = true;
    }
    else {
      this.spinnerService.show();
      let supportMessage = {
        AccountId: this.currentAccount.AccountId.toString(),
        OrgUnitId: this.currentAccount.OrgUnitId.toString(),
        Message: this.issueMessage
      }
      this.accountDetailsService.reportOutage(supportMessage)
        .subscribe((res) => {
          if (res.success) {
            this.showSuccessReport = true;
            this.showReportIssue = false;
            this.issueMessage = undefined;
            this.showIssueButton = false;
          } else {
            this.error = "An error occurred. Please contact your system administrator.";
            this.showError = true;
          }
          () => this.spinnerService.hide();
          });
    }
  }

  getFlowAlarms(orgUnitId, deviceId) {
    this.alarmsService.getAlarms(orgUnitId, deviceId, "1")
      .subscribe((alarms) => {
        if (alarms.success === false) {
          console.log('user has no alarms set');
        }
        else {
          this.hasAlarmContactInfo = true;
          this.alarms = alarms.modelRet;

          if (alarms.modelRet.contactInfoEmail !== "" && alarms.modelRet.contactInfoEmail !== null) {
            this.hasAlarmEmail = true;
            this.alarmEmail = alarms.modelRet.contactInfoEmail;
          }

          if (alarms.modelRet.contactInfoText !== "" && alarms.modelRet.contactInfoText !== null) {
            this.hasAlarmPhone = true;
            this.alarmPhone = this.formatPhoneNumber(alarms.modelRet.contactInfoText);
          }
        }
      });
  }

  getAllAlarms(orgUnitId, deviceId) {   
    this.alarmsService.getAllAlarms(orgUnitId, deviceId)
      .subscribe((alarms) => {
        if (alarms.success === false) {
          console.log('user has no alarms set');
        }
        else {
          this.hasAlarmContactInfo = true;
          this.alarms = alarms.modelRet;
          let textAlarmList = [];
          let emailAlarmList = [];
          for (var i = 0; this.alarms.length > i; i++) {
            var a = this.alarms[i];
            if (a.alarmTypeId === 1 && a.contactInfoText !== '') {
              textAlarmList.push('Flow Alerts');
            }
            if (a.alarmTypeId === 2 && a.contactInfoText !== '') {
              textAlarmList.push('Vacation Alerts');
            }
            if (a.alarmTypeId === 4 && a.contactInfoText !== '') {
              textAlarmList.push('Cold Weather Alerts');
            }
            if (a.alarmTypeId === 5 && a.contactInfoText !== '') {
              textAlarmList.push('Water Usage Alerts');
            }

            if (a.alarmTypeId === 1 && a.contactInfoEmail !== '') {
              emailAlarmList.push('Flow Alerts');
            }
            if (a.alarmTypeId === 2 && a.contactInfoEmail !== '') {
              emailAlarmList.push('Vacation Alerts');
            }
            if (a.alarmTypeId === 4 && a.contactInfoEmail !== '') {
              emailAlarmList.push('Cold Weather Alerts');
            }
            if (a.alarmTypeId === 5 && a.contactInfoEmail !== '') {
              emailAlarmList.push('Water Usage Alerts');
            }
          }

          this.textAlarmTypes = textAlarmList.join(", ");
          this.emailAlarmTypes = emailAlarmList.join(", ");

          const hasNoValue = (currentValue) => currentValue === "";

          const unique = (value, index, self) => {
            return self.indexOf(value) === index;
          }

          let hasNoEmails = alarms.modelRet.map(a => a.contactInfoEmail).every(hasNoValue);
          let hasNoPhoneNumbers = alarms.modelRet.map(a => a.contactInfoText).every(hasNoValue);

          if (!hasNoEmails) {
            this.emails = alarms.modelRet.map(a => a.contactInfoEmail).filter(unique).filter(function (entry) { return entry.trim() != ''; });
            this.hasAlarmEmail = true;
          }
          if (!hasNoPhoneNumbers) {

            let phoneArr = alarms.modelRet.map(a => a.contactInfoText).filter(unique).filter(function (entry) { return entry.trim() != ''; });

            for (var i = 0; i < phoneArr.length; i++) {
              var item = phoneArr[i];
              this.phoneNums.push(this.formatPhoneNumber(item));
            }

            this.hasAlarmPhone = true;
          } 
        }
      });
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }

}



// WEBPACK FOOTER //
// ./src/app/status-container/status-container.component.ts